import { render, staticRenderFns } from "./default.amp.vue?vue&type=template&id=a1dd5790&"
import script from "./default.amp.vue?vue&type=script&lang=js&"
export * from "./default.amp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AmpHeader: require('/home/hadicod/source/components/amp/header/index.vue').default,AmpFooter: require('/home/hadicod/source/components/amp/footer/index.vue').default,SvgEmail: require('/home/hadicod/source/components/svg/email.vue').default,SvgFacebook: require('/home/hadicod/source/components/svg/facebook.vue').default,SvgInstagram: require('/home/hadicod/source/components/svg/instagram.vue').default})
